export const LOAD_COOKIE_CONSENT = 'true' === 'true';



// WEBPACK FOOTER //
// ./js/config/cookie-consent.js